import React, { useEffect, useState, useRef, useCallback } from 'react';
import Navbar from '../../navbar';
import Header from '../../header';
import { useDispatch, useSelector } from 'react-redux';
import { fetchApplication, updateApplication } from '../../../store/reducers/applicationSlice'
import classes from '../appForm/style.module.css'
import { useParams } from 'react-router-dom';
import { setFormFieldData, hideAllPagesExceptCurrentFormPage, prepareHtmlForPdf } from '../../../utility/utility';
import { updateApplicationData, safePdf } from '../../../store/reducers/applicationSlice';
import { createNotification } from "../../../store/reducers/notificationSlice";
import { getSignature, getAttachments } from '../../../store/reducers/fileSlice';
import DescripanciesBox from './discepancies-box';
// import Form from './form';
import FormHeader from '../forms/formHeader/formHeader';
import AddAttachment from './attachments';
import FormLoader from '../forms/formLoader';
import { useNavigate } from "react-router-dom";

const Descripancies = ({ viewMode = 'auto' }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const authToken = user.access_token;
  const params = useParams();
  const application = useSelector((state) => state.applications.application);
  const [pageIds, setPageIds] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [formIds, setFormIds] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [applicationDicrepancies, setApplicationDiscrepancies] = useState(null);
  const [selectedFieldData, setSelectedFieldData] = useState({});
  const [loading, setLoading] = useState(true);

  // Debug log for selectedFieldData changes (can be removed in production)
  useEffect(() => {
  }, [selectedFieldData]);

  const [inputFields, setInputFields] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [signatureIds, setSignatureIds] = useState([]);
  const [signatureImage, setSignatureImage] = useState('')
  const [showAttachments, setShowAttachments] = useState(false);
  const navigate = useNavigate();

  // Reference to attachments component's saveChanges function
  const attachmentsRef = useRef(null);

  // Clear data when application ID changes to prevent showing previous application data
  useEffect(() => {
    setLoading(true);
    setIsLoaded(false);
    setCurrentPage(1);
    setShowAttachments(false);
    // Reset user interaction flag
  }, [params.id]);

  useEffect(() => {
    if (dispatch && params.id && authToken) {
      setLoading(true);
      dispatch(fetchApplication({ id: params.id, accessToken: authToken }))
        .then(() => {
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching application:', error);
          setLoading(false);
        });
    }
  }, [dispatch, params.id, authToken])

  useEffect(() => {
    const timestamp = new Date().toLocaleTimeString();
    const runAsyncFunctions = async () => {
      if (isLoaded && user && application) {

        setTimeout(async () => {
          try {
            await setFormFieldData((application.json_data));
            setApplicationDiscrepancies(application.discrepancies);
            setSelectedFieldData(application.discrepancies);
            setInputFields(application.json_data);
          } catch (error) {
            console.error('Error setting form field data:', error);
          }
        }, 500);

        let userId = application.user_id || user.user.id

        // Use Promise.allSettled to handle both API calls gracefully
        const [signatureResult, attachmentsResult] = await Promise.allSettled([
          getSignature({ userId: userId, applicationId: params.id, authToken }),
          getAttachments({ userId: userId, applicationId: params.id, authToken })
        ]);

        // Handle signature result
        if (signatureResult.status === 'fulfilled' && signatureResult.value) {
          setSignatureImage(signatureResult.value);
        } else {
          const error = signatureResult.reason;
          if (error && error.message === 'NOT_FOUND') {
          } else if (error && error.message === 'SERVER_ERROR') {
          } else {
          }
        }

        // Handle attachments result
        if (attachmentsResult.status === 'fulfilled' && attachmentsResult.value) {
          const files = attachmentsResult.value.map(filename => ({ name: filename }));
          setUploadedFiles(files);
        } else {
          const error = attachmentsResult.reason;
          if (error && error.message === 'NOT_FOUND') {
          } else if (error && error.message === 'SERVER_ERROR') {
          } else {
          }
          setUploadedFiles([]);
        }
      }
    };

    runAsyncFunctions();
  }, [isLoaded, user, application, authToken, params.id]);

  // click handler for discrepancies
  const handleInputChange = React.useCallback((event) => {

    const fieldId = 'dis_' + event.target.id;
// Debug log
    // Mark that user has interacted
    setSelectedFieldData((prevFields) => {
      const newFields = { ...prevFields };
      if (user?.user?.user_role === 'company_admin' && application?.state === 'application_sent_to_discrepancy_by_company') {
        if (newFields[fieldId]) {
          delete newFields[fieldId];
          event.target.style.backgroundColor = '';
// Debug log
        } else {
          newFields[fieldId] = { value: '', check: true };
          event.target.style.backgroundColor = '#ff0000';
// Debug log
        }

      }
      return newFields;
    });

  }, [user?.user?.user_role, application?.state]);

  // attach/remove listeners for discrepancies and restore highlighting
  useEffect(() => {
// Debug log
    formIds.forEach((id) => {
      const inputField = document.getElementById(id);
      if (inputField) {
        inputField.removeEventListener('click', handleInputChange);
        inputField.addEventListener('click', handleInputChange);
// Debug log

        // Restore red highlighting for fields that have discrepancies
        const fieldId = 'dis_' + id;
        if (selectedFieldData[fieldId]) {
          inputField.style.backgroundColor = '#ff0000';
// Debug log
        }
      } else {
// Debug log
      }
    });
    return () => {
      formIds.forEach((id) => {
        const inputField = document.getElementById(id);
        if (inputField) {
          inputField.removeEventListener('click', handleInputChange);
        }
      });
    };
  }, [formIds, handleInputChange, selectedFieldData]);

  // Restore highlighting when selectedFieldData changes (for page reload/navigation back)
  useEffect(() => {
    if (Object.keys(selectedFieldData).length > 0 && formIds.length > 0) {
      Object.keys(selectedFieldData).forEach(fieldId => {
        const formFieldId = fieldId.replace('dis_', '');
        const inputField = document.getElementById(formFieldId);
        if (inputField) {
          inputField.style.backgroundColor = '#ff0000';
        }
      });
    }
  }, [selectedFieldData, formIds, isLoaded]);

  // inject signature with improved handling
  useEffect(() => {
    if (formIds.length > 0 && signatureImage && isLoaded) {
      formIds.forEach((id) => {
        const inputField = document.getElementById(id);
        if (inputField?.type === 'image') {
          const computed = window.getComputedStyle(inputField);
          const originalWidth = parseFloat(computed.width) || 0;
          const originalTop = parseFloat(computed.top) || 0;
          const height = (originalWidth * 114) / 179;

          inputField.style.height = height + 'px';
          inputField.style.top = originalTop - height + 20 + 'px';
          inputField.src = signatureImage;
          inputField.style.objectFit = 'contain';
          inputField.style.pointerEvents = 'none';
          // setImageData(signatureImage); // Removed - imageData state not needed
        }
      });
    }
  }, [signatureImage, isLoaded, formIds])

  // Handle signature display in form - similar to app-edit.js
  useEffect(() => {
    if (signatureImage && signatureIds.length > 0) {
      signatureIds.forEach(id => {
        const imageInput = document.getElementById(id);
        if (imageInput && imageInput.type === 'image') {
          // Directly set the src of the image input
          let originalWidth = window.getComputedStyle(imageInput).width.replace("px", "");
          let originalTop = window.getComputedStyle(imageInput).top.replace("px", "");
          let height = (originalWidth * 114) / 179;
          imageInput.style.height = height + "px";
          imageInput.style.top = (originalTop - height) + 20 + "px";
          imageInput.src = signatureImage;
          imageInput.style.objectFit = 'contain';
          imageInput.style.pointerEvents = 'none';
        }
      });
    }
  }, [signatureImage, signatureIds]);

  useEffect(() => {
    if (pageIds) {
      hideAllPagesExceptCurrentFormPage(pageIds, currentPage);
    }
  }, [pageIds, currentPage])

  const handleFormInputChange = useCallback((event) => {
    const { id, value } = event.target;

    setInputFields(prevInputFields => ({
      ...prevInputFields,
      [id]: value,
    }));
// Debug log
  }, [inputFields]);

  const handleCheckBoxChange = useCallback((event) => {
    const { id, checked, value } = event.target;

    setInputFields(prevInputFields => {
      // If the checkbox is checked, add it to inputFields
      if (checked) {
        return {
          ...prevInputFields,
          [id]: value,
        };
      } else {
        // If the checkbox is unchecked, remove it from inputFields
        const { [id]: removedValue, ...remainingFields } = prevInputFields;
        return remainingFields;
      }
    })
  }, []);

  const attachEventHandlers = useCallback(() => {
    let tempSignatureIds = []

    formIds.forEach(id => {
      const inputField = document.getElementById(id);
      if (inputField.type === 'image') {
        tempSignatureIds.push(id);
      } else if (inputField.type === 'checkbox') {
        inputField.addEventListener('change', handleCheckBoxChange)
      } else {
        // For discrepancies page, we only handle form input changes, not clicks
        // The click handlers for discrepancies are handled separately
        inputField.addEventListener('change', handleFormInputChange);
      }
    });
    setSignatureIds(tempSignatureIds);
  }, [formIds, handleCheckBoxChange, handleFormInputChange]);

  useEffect(() => {
    if (formIds.length > 0) {
      attachEventHandlers();
    }
  }, [formIds.length, attachEventHandlers, formIds]);

  useEffect(() => {
  }, [inputFields]);

  const handleSubmitWithLoading = async (e) => {
    let htmlForm = document.getElementById("DocumentPDF").outerHTML;

    // Determine the new status based on current application status and user role
    let newStatus = "discrepancies"; // default status

    // Check multiple possible conditions for status change
    const shouldChangeStatusToAssigned = (
      (application?.state === "application_sent_to_discrepancy_by_company" || application?.state === "discrepancies") &&
      user?.user?.user_role === "company_admin"
    );

    const shouldChangeStatusToCompany = (
      application?.state === "dicrepancy_application_assigned_to_comapany_user" &&
      user?.user?.user_role === "employee"
    );

    if (application?.state === 'descrepency_GB_Employee') {
      newStatus = 'descrepency_GB_GB';
    } else if (shouldChangeStatusToAssigned) {
      newStatus = "dicrepancy_application_assigned_to_comapany_user";
    } else if (shouldChangeStatusToCompany) {
      newStatus = "application_sent_to_discrepancy_by_company";
    } else {
    }

    // Update application data with the determined status
    await dispatch(updateApplicationData({
      token: authToken,
      id: params.id,
      json_data: inputFields,
      userId: user.user.id,
      files: uploadedFiles,
      form: application.name,
      state: newStatus
    }));

    // Handle different status changes and navigation in one place
    let targetRoute = null;

    // Base route decisions
    if (newStatus === 'descrepency_GB_GB') {
      targetRoute = '/discrepancies-gb';
    } else if (user?.user?.user_role === 'company_admin' && (application?.state === 'descrepency_GB_Company' || newStatus === 'descrepency_GB_Company')) {
      targetRoute = '/in-process-applications';
    } else if (user?.user?.user_role === 'employee' && (application?.state === 'descrepency_GB_Company' || newStatus === 'descrepency_GB_Company')) {
      targetRoute = '/discrepancies-gb';
    }

    // Status-specific updates that also set/override route
    if (newStatus === "dicrepancy_application_assigned_to_comapany_user") {
      await dispatch(updateApplication({
        token: authToken,
        id: params.id,
        state: newStatus,
        currentTime: new Date().toLocaleTimeString(),
        statusMessage: "Discrepancy company assigned to employee"
      }));
      targetRoute = '/discrepancies-company';
    } else if (newStatus === "application_sent_to_discrepancy_by_company") {
      await dispatch(updateApplication({
        token: authToken,
        id: params.id,
        state: newStatus,
        currentTime: new Date().toLocaleTimeString(),
        statusMessage: "Discrepancy sent back to company"
      }));
      targetRoute = user?.user?.user_role === 'company_admin' ? '/discrepancies-company' : '/in-review';
    }

    // Trigger notification based on the new status
    dispatch(createNotification({
      user_id: application?.user_id || user.user.id,
      applicationId: params.id,
      applicationName: application.name,
      status: newStatus,
      accessToken: authToken,
      sendToCompanyAdmins: true,
      sendToGamingBoardAdmins: newStatus === 'descrepency_GB_GB',
      companyName: user.user?.company_name,
      employeeName: application.userName || application.name
    }));

    // Fallback based on view mode to avoid ambiguous redirects
    if (!targetRoute) {
      if (viewMode === 'company') {
        targetRoute = '/discrepancies-company';
      } else if (viewMode === 'gb') {
        targetRoute = '/discrepancies-gb';
      }
    }

    if (targetRoute) {
      navigate(targetRoute);
    }

    dispatch(safePdf({
      htmlForm: prepareHtmlForPdf(htmlForm, inputFields, pageIds),
      user: { id: application.user_id },
      id: params.id,
      token: authToken
    }));

  };

  const previousPage = () => {
    if (currentPage === pageIds.length + 1) {
      setShowAttachments(false);
      showDiv(currentPage - 1);
      setCurrentPage(currentPage - 1)
    } else {
      if (currentPage - 1 >= 1) {
        hideDiv(currentPage);
        showDiv(currentPage - 1);
        setCurrentPage(currentPage - 1);
      }
    }
  }

  const nextPage = () => {
    if (currentPage + 1 <= pageIds.length) {
      hideDiv(currentPage);
      showDiv(currentPage + 1);
      setCurrentPage(currentPage + 1);
    } else if (currentPage + 1 <= pageIds.length + 1) {
      hideDiv(currentPage);
      setCurrentPage(currentPage + 1);
      setShowAttachments(true);
    }
  }
  const hideDiv = (pageNo) => {
    const pageDiv = document.getElementById("page" + pageNo);
    pageDiv.style.display = "none";
  }

  const showDiv = (pageNo) => {
    const pageDiv = document.getElementById("page" + pageNo);
    pageDiv.style.display = "";
  }

  const handlePageChange = (number) => {
    if (number > 0 && number <= pageIds.length + 1) {
      if (number === pageIds.length + 1) {
        hideDiv(currentPage);
        setCurrentPage(number);
        setShowAttachments(true);
      } else {
        if (currentPage === pageIds.length + 1) {
          setShowAttachments(false)
          showDiv(number)
          setCurrentPage(number)
        } else {
          hideDiv(currentPage);
          showDiv(number);
          setCurrentPage(number);
        }
      }
    }
  }

  // Function to call saveChanges from attachments component
  const handleSaveChanges = async () => {
    if (attachmentsRef.current && attachmentsRef.current.saveChanges) {
      await attachmentsRef.current.saveChanges();
    } else {
    }
  };

  // Function to handle signature update from AddAttachment component
  const handleSignatureUpdate = (signatureData) => {
    setSignatureImage(signatureData);
  };

  // Show loading spinner while data is loading
  if (loading || !application) {

    return (
      <div>
        <Navbar />
        <Header userRole={user.user.user_role} applicationState={application.state} />
        <div className='wrapper'>
          <div className='boxAppBoard boxWhite'>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '400px',
              flexDirection: 'column'
            }}>
              <div style={{
                border: '4px solid #f3f3f3',
                borderTop: '4px solid #3498db',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                animation: 'spin 1s linear infinite'
              }}></div>
              <p style={{ marginTop: '20px', color: '#666' }}>Loading application data...</p>
            </div>
          </div>
        </div>
        <style jsx>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      <Header />
      <div className='wrapper'>
        <div className='boxAppBoard boxWhite'>
          <div className="stickyFormHeader">
            <FormHeader
              applicationName={application?.name || 'Loading...'}
              applicationId={params.id}
              userId={application?.user_id || user.user?.id}
              nextPage={nextPage} previousPage={previousPage}
              currentPage={currentPage} totalPages={pageIds.length + 1}
              handleSubmitWithLoading={handleSubmitWithLoading}
              handlePageChange={handlePageChange}
              displayInReview={true}
              userRole={user.user.user_role}
              json_data={inputFields}
              pageIds={pageIds}
              saveChanges={handleSaveChanges}
            />
          </div>

          <div className="boardHeader">

          </div>

          <div className={classes['board-content']}>
            <div className='disarea'>
              <DescripanciesBox
                selectedFieldData={selectedFieldData}
                setSelectedFieldData={setSelectedFieldData}
                formId={params.id}
                descrepancies={applicationDicrepancies || {}}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                applicationState={application?.state}
              />
              {!isLoaded && (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                  <h3>Loading Form...</h3>
                  <p>Please wait while the form is being loaded.</p>
                </div>
              )}
              <div>
                <FormLoader applicationName={application?.name} setFormIds={setFormIds} setPageIds={setPageIds} setIsLoaded={setIsLoaded} />
                {showAttachments && (
                  <div>
                    <AddAttachment
                      ref={attachmentsRef}
                      applicationId={params.id}
                      userId={application?.user_id || user.user?.id}
                      signatureIds={signatureIds}
                      setUploadedFiles={setUploadedFiles}
                      uploadedFiles={uploadedFiles}
                      applicationState={application?.state || "discrepancies"}
                      applicationName={application?.name}
                      jsonData={inputFields}
                      signatureImage={signatureImage}
                      onSignatureUpdate={handleSignatureUpdate}
                      embedded={false}
                    />
                  </div>
                )}

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}
export default Descripancies